import React, { memo } from "react";

// Redux
import { useSelector } from "react-redux";

const WidgetButton = ({
  d,
  transform,
  done,
  transformone,
  fillcolor,
  cx,
  cy,
  r,
  stroke,
  strokLinecap,
  strokeLinejoin,
  strokeWidth,
}) => {
  const { mainTheme } = useSelector((state) => state.Layout);

  return (
    <svg
      className={mainTheme === "light" ? "btn nav-btn-light" : "btn nav-btn"}
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
    >
      <g fill="none" fillRule="evenodd">
        <circle cx={cx} cy={cy} r={r} fill={fillcolor} />
        <g
          stroke={stroke}
          strokeLinecap={strokLinecap}
          strokeLinejoin={strokeLinejoin}
          strokeWidth={strokeWidth}
        >
          <path d={d} transform={transform} />
          <path d={done} transform={transformone} />
        </g>
      </g>
    </svg>
  );
};

export default memo(WidgetButton);
